export default "__VITE_ASSET__CyXm5L2X__"